import { Typography } from '@design-system/components/typography/typography';
import { MediaTooltips } from './TooltipContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { Media } from '../models/workout.domain';
import { Player } from '../../../common/videos/Player';
import { ContentFilters } from '@client/new/common/library/helpers';

export const MediaPreview = ({
  media,
  videoType,
  removeVideo,
  youtubeId,
  disabled,
}: {
  media?: Media;
  videoType: ContentFilters;
  removeVideo?: () => void;
  youtubeId?: string;
  disabled?: boolean;
}) => {
  if (!media) return null;
  if (youtubeId) {
    return (
      <div className="flex flex-col">
        <div className="flex justify-between">
          <Typography className="pb-1">Media</Typography>
          <MediaTooltips />
        </div>
        <div className="rounded-[10px] w-[200px] h-[220px] bg-black relative">
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}`}
            className="w-full h-full"
          />
          {disabled ? null : (
            <FontAwesomeIcon
              icon={faCircleXmark}
              className="absolute top-3 right-3 text-white opacity-60 cursor-pointer"
              onClick={() => removeVideo?.()}
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <div className="flex justify-between">
        <Typography className="pb-1">Media</Typography>
        {videoType === 'short' ? <MediaTooltips /> : null}
      </div>
      <div className="rounded-[10px] w-[174px] h-[249px] bg-black relative">
        <Player
          src={media.videoUrl || ''}
          poster={media.videoThumbnailUrl}
          duration={media?.duration || 0}
          height={249}
          width={174}
          hideDuration={true}
        />
        {disabled ? null : (
          <FontAwesomeIcon
            icon={faCircleXmark}
            className="absolute top-3 right-3 text-white opacity-60 cursor-pointer"
            onClick={removeVideo}
          />
        )}
      </div>
    </div>
  );
};
